import axios from "./axios";
import graphql from "./graphql";
import errorHandling from "./error-handling";

export default function () {
  axios();
  graphql();
  errorHandling();
}
